import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    programs: [],
    isLoading: false,
    error: false
}

const programSlice = createSlice({
    name: "Programs",
    initialState,
    reducers: {
        setPrograms: (state, action) => {
            state.programs = action.payload
        },
        setLoading: (state, action) => {
            state.isLoading = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
        }
    }
});

export const { setPrograms, setLoading, setError } = programSlice.actions;
export const programReducers = programSlice.reducer;